import { ChangeQItem, ChangeQItemArgs } from './item';

export interface ReportLayoutChangeQItemArgs extends ChangeQItemArgs {
    isPostJsonFinished?: boolean;
}

export class ReportLayoutChangeQItem extends ChangeQItem {

    isPostJsonFinished?: boolean;

    constructor(data?: ReportLayoutChangeQItemArgs) {
        super(data);

        const fileData = data || {
            isPostJsonFinished: false
        };

        this.isPostJsonFinished = fileData.isPostJsonFinished;
    }

    update(args = {} as any): ReportLayoutChangeQItem {
        return new ReportLayoutChangeQItem({
            ...this.toObject(),
            ...args
        });
    }

    toObject(): object {
        return {
            ...super.toObject(),
            isPostJsonFinished: this.isPostJsonFinished
        };
    }
}



// WEBPACK FOOTER //
// ./src/core/services/sync-up/report-layout-item.ts